import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "bp-general-banner",
	templateUrl: "./bp-general-banner.component.html",
	styleUrls: ["./bp-general-banner.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpGeneralBannerComponent {
	@Input()
	public iconSrc: string = null;

	@Input()
	public translationKeyPrefix: string;

	@Input()
	public value: string;

	@Input() actionBtnType: "normal" | "inverse" = "inverse";

	@Output()
	public actionClicked: EventEmitter<void> = new EventEmitter<void>();
}
